module.exports = __webpack_public_path__ + "assets/align-right.ea0398aa.svg";